var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.403h-4v-6H4v6H0l7 7 7-7zm-8 2v-6h2v6h1.17L7 10.573l-2.17-2.17H6zm-6 7h14v2H0v-2z",
    fill: "#FC6F30"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTQgNi40MDMzMkgxMFYwLjQwMzMySDRWNi40MDMzMkgwTDcgMTMuNDAzM0wxNCA2LjQwMzMyWk02IDguNDAzMzJWMi40MDMzMkg4VjguNDAzMzJIOS4xN0w3IDEwLjU3MzNMNC44MyA4LjQwMzMySDZaTTAgMTUuNDAzM0gxNFYxNy40MDMzSDBWMTUuNDAzM1oiIGZpbGw9IiNGQzZGMzAiLz4KPC9zdmc+Cg==";
export { SvgDownload as ReactComponent };